export default "__VITE_ASSET__lN6rhgPH__"